import { versionedHttpCollection } from "us.helper/http/collection";

export const additionalInformation = {
  get: async (debtorNo: number): Promise<any> => {
    return new Promise<{}>(async (resolve, reject) => {
      try {
        const { data, status } = await versionedHttpCollection.get(
          "entityservice",
          `debtor/otherinfo?debtorNo=${debtorNo}`,
          {},
          "v1"
        );
        resolve({ data, status });
      } catch (error) {
        reject(error);
      }
    });
  },
  add: async (params: any): Promise<any> => {
    return new Promise<{}>(async (resolve, reject) => {
      try {
        const { data, status } = await versionedHttpCollection.post(
          "entityservice",
          `debtor/otherinfo`,
          params,
          "v1"
        );
        resolve({ data, status });
      } catch (error) {
        reject(error);
      }
    });
  },
  edit: async ({ saveParams, infoId }: any): Promise<any> => {
    return new Promise<{}>(async (resolve, reject) => {
      try {
        const { data, status } = await versionedHttpCollection.put(
          "entityservice",
          `debtor/otherinfo/${infoId}`,
          saveParams,
          "v1"
        );
        resolve({ data, status });
      } catch (error) {
        reject(error);
      }
    });
  },
  deleteInfo: async ({ infoId }: any): Promise<any> => {
    return new Promise<{}>(async (resolve, reject) => {
      try {
        const { data, status } = await versionedHttpCollection.delete(
          "entityservice",
          `debtor/otherinfo`,
          infoId,
          {},
          "v1"
        );
        resolve({ data, status });
      } catch (error) {
        reject(error);
      }
    });
  },
  getMetaData: async (): Promise<any> => {
    return new Promise<{}>(async (resolve, reject) => {
      try {
        const { data, status } = await versionedHttpCollection.get(
          "entityservice",
          `debtor/otherinfometadata`,
          {},
          "v1"
        );
        resolve({ data, status });
      } catch (error) {
        reject(error);
      }
    });
  },

  getSPDataValues: async (dataTypeId: number): Promise<any> => {
    return new Promise<{}>(async (resolve, reject) => {
      try {
        const { data, status } = await versionedHttpCollection.get(
          "bmdservice",
          `bmddatatypevalues/${dataTypeId}`,
          {},
          "v1"
        );
        resolve({ data, status });
      } catch (error) {
        reject(error);
      }
    });
  },
};
